import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/css/header.css";
import "./assets/css/signup.css";
import "./assets/css/login.css";
import "./assets/css/dashboard.css";
import "react-phone-number-input/style.css";
import "./assets/css/modal.css";
import "./assets/css/virtualcenter.css";
import "./assets/css/prayersection.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { store } from "./redux/store";
import { Provider } from "react-redux";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
